import React from 'react';
import './App.css';

function App() {
  return (
    <div className="app">
      <header className="header">
        <div className="container">
          <div className="logo">AWS</div>
          <nav className="nav">
            <a href="#skillbuilder">Training</a>
            <a href="#guidance">Prescriptive Guidance</a>
            <a href="#resources">Resources</a>
          </nav>
        </div>
      </header>

      <main className="main">
        <section className="hero">
          <div className="container">
            <div className="hero-content">
              <h1>AWS Agentic AI Factory for Partners</h1>
              <p>Build intelligent, autonomous AI systems that can reason, plan, and act independently to solve complex problems.</p>
              <div className="cta-buttons">
                <a href="https://amazonexteu.qualtrics.com/jfe/form/SV_8HUj17UkCHkx2lw" target='blank' className="btn-primary">Get Started</a>
                <a href="https://aws.amazon.com/blogs/machine-learning/enabling-customers-to-deliver-production-ready-ai-agents-at-scale/" target='blank' className="btn-secondary">Learn more</a>
              </div>
            </div>
          </div>
        </section>

        <section className="features" id="survey">
          <div className="container">
            <a href="https://amazonexteu.qualtrics.com/jfe/form/SV_8HUj17UkCHkx2lw" target='blank' className="feature-card">
            <h3>AWS Agentic AI Factory - Early Adoption Program Registration</h3>
            </a>
          </div>
        </section>

        <section className="guidance" id="sample">
          <div className="container">
            <h3>Agentic AI Factory Platform Starter Kit</h3>
            <div className="feature-grid">
              <a href="https://github.com/aws-samples/sample-agentic-ai-factory" target='blank' className="feature-card">
                <h4>GihHub AWS-Sample</h4>
                <h4>github.com/aws-samples/sample-agentic-ai-factory</h4>
                <p>The Agentic AI Factory is a multi-agent AI system for enterprise application transformation and adoption using AWS Bedrock AgentCore and AWS native services to provide a starter platform to build from, and demonstrate different agent development practices and patterns for multi-agent collaberation. </p>
              </a>
            </div>
          </div>
        </section>

        <section className="features" id="skillbuilder">
          <div className="container">
            <h3>SkillBuilder Persona based training</h3>
            <div className="feature-grid">
              <a href="https://skillbuilder.aws/learn/4C55X3JMP7/aws-partner-accelerating-value-with-ai-agents/YZE9TGFD2N" target='blank' className="feature-card">
                <h4>Non Technical</h4>
                <p>This fundamental course introduces AWS Partners to agentic AI. It covers the evolution of generative AI, from assistants to agents, and explores the capabilities of agentic AI systems. Participants will learn about AI agents and why customers choose AWS for their agentic AI needs. The course also delves into the three primary paths for implementing agentic AI, based on desired levels of customization and control. Key AWS services for agentic AI, including Amazon Q and Amazon Bedrock, are explored. By the end of the course, partners will be able to help customers with their agentic AI adoption to accelerate value for their business.</p>
              </a>
              <a href="https://skillbuilder.aws/learn/MAGXG4T7FQ/aws-partnercast--agentic-ai-on-aws--technical/D55QXCZM4T" target='blank' className="feature-card">
                <h4>Technical</h4>
                <p>Discover how to harness the power of AI agents in AWS through this comprehensive technical session. We'll explore AWS Bedrock Agents and demonstrate how to create agentic architectures that can handle complex tasks through multi-agent collaboration. The session will also provide practical insights into integrating popular open-source frameworks like Langgraph to enhance your agent development workflow. Whether you're new to AI agents or looking to optimize your existing implementations, this webinar will equip you with actionable knowledge to build more intelligent and efficient AI solutions on AWS.</p>
              </a>
            </div>
          </div>
        </section>

        <section className="guidance" id="guidance">
          <div className="container">
            <h3>AWS Agentic AI Prescriptive Guidance</h3>
            <div className="guidance-list">
              <a href="https://docs.aws.amazon.com/prescriptive-guidance/latest/strategy-operationalizing-agentic-ai/introduction.html" target='blank' className="guidance-item">
                <h4>Operationalizing agentic AI on AWS</h4>
                <p>This document provides an organizational strategy to transform agentic AI from isolated experiments into enterprise-scale, value-generating infrastructure. It can help you embed intelligent agents across workflows with governance, scalability, and business alignment.</p>
              </a>
              <a href="https://docs.aws.amazon.com/prescriptive-guidance/latest/agentic-ai-foundations/introduction.html" target='blank' className="guidance-item">
                <h4>Foundations of agentic AI on AWS</h4>
                <p>This guide introduces the principles that define modern software agents and outlines their evolution toward agentic AI. To explain this shift, the guide provides the conceptual background and then traces the evolution of software agents to agentic AI.</p>
              </a>
              <a href="https://docs.aws.amazon.com/prescriptive-guidance/latest/agentic-ai-patterns/introduction.html" target='blank' className="guidance-item">
                <h4>Agentic AI patterns and workflows on AWS</h4>
                <p>This guide is intended for architects, developers, and product leaders who want to build intelligent applications that go beyond static logic, symbolic logic, and deterministic automation.</p>
              </a>
              <a href="https://docs.aws.amazon.com/prescriptive-guidance/latest/agentic-ai-frameworks/introduction.html" target='blank' className="guidance-item">
                <h4>Agentic AI frameworks, protocols, and tools on AWS</h4>
                <p>On AWS, organizations can leverage agentic AI to automate complex workflows, enhance decision-making processes, and create more responsive systems. This guide provides information about key components that are necessary to build effective agentic AI solutions.</p>
              </a>
              <a href="https://docs.aws.amazon.com/prescriptive-guidance/latest/agentic-ai-serverless/introduction.html" target='blank' className="guidance-item">
                <h4>Building serverless architectures for agentic AI on AWS</h4>
                <p>This guide outlines the strategic and technical foundations for building AI-native, serverless architectures on AWS. These architectures are scalable, cost-effective, and capable of delivering real-time intelligence without the complexity of managing infrastructure.</p>
              </a>
              <a href="https://docs.aws.amazon.com/prescriptive-guidance/latest/agentic-ai-multitenant/introduction.html" target='blank' className="guidance-item">
                <h4>Building multi-tenant architectures for agentic AI on AWS</h4>
                <p>This guide's goal is to explore various dimensions of agentic footprints. This includes reviewing various agent deployment and consumption patterns and highlighting different strategies for creating agents that address architectural goals. It also means looking at how agents might be consumed in a multi-tenant environment by introducing internal constructs that are typically required in a multi-tenant setting.</p>
              </a>
            </div>
          </div>
        </section>

        <section className="resources" id="resources">
          <div className="container">
            <h3>Other AWS resources</h3>
            <div className="resources-list">
              <a href="https://pages.awscloud.com/global-ln-gc-400-f1-agentic-ai-learn.html" target='blank' className="resource-item">
                <h4>exec brief</h4>
                <p>Executive brief on agentic AI</p>
              </a>
              <a href="https://aws.amazon.com/blogs/opensource/open-protocols-for-agent-interoperability-part-1-inter-agent-communication-on-mcp/" target='blank' className="resource-item">
                <h4>blog post</h4>
                <p>Open Protocols for Agent Interoperability Part 1: Inter-Agent Communication on MCP</p>
              </a>
              <a href="https://aws.amazon.com/blogs/machine-learning/syngenta-develops-a-generative-ai-assistant-to-support-sales-representatives-using-amazon-bedrock-agents/" target='blank' className="resource-item">
                <h4>blog post</h4>
                <p>Syngenta develops a generative AI assistant to support sales representatives using Amazon Bedrock Agents</p>
              </a>
              <a href="https://aws.amazon.com/blogs/machine-learning/creating-asynchronous-ai-agents-with-amazon-bedrock/" target='blank' className="resource-item">
                <h4>blog post</h4>
                <p>Creating asynchronous AI agents with Amazon Bedrock</p>
              </a>
              <a href="https://aws.amazon.com/blogs/devops/multi-agent-collaboration-with-strands/" target='blank' className="resource-item">
                <h4>blog post</h4>
                <p>Multi Agent Collaboration with Strands</p>
              </a>
              <a href="https://docs.aws.amazon.com/bedrock/latest/userguide/agents.html" target='blank' className="resource-item">
                <h4>Service Documentation</h4>
                <p>Automate tasks in your application using AI agents</p>
              </a>
              <a href="https://aws.amazon.com/blogs/opensource/introducing-strands-agents-an-open-source-ai-agents-sdk/" target='blank' className="resource-item">
                <h4>blog post</h4>
                <p>Introducing Strands Agents, an Open Source AI Agents SDK</p>
              </a>
            </div>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="container">
          <p>&copy; 2025 Amazon Web Services, Inc. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
